export const salesCsvFilter = (tab, role, tile, content) => {
  // console.log(
  //   "CSV DETAILS ARRIVING in module, tab, role, tile, content format: ",
  //   module,
  //   tab,
  //   role,
  //   tile,
  //   content
  // );
  let csv = content;
  ({
    ZD: () => {
      ({
        Primary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Secondary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["JC CODE"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Tertiary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Gross Amount"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Count"] = obj["retCount"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Gross Amount"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Count"] = obj["retCount"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Gross Amount"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Count"] = obj["retCount"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Gross Amount"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Count"] = obj["retCount"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["QTY"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["QTY"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["QTY"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["QTY"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        IMEI: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerId"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerId"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerId"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerId"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
      return csv;
    },
    RDS: () => {
      ({
        Purchase: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Tertiary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer ID"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Gross Amount"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Count"] = obj["retCount"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer ID"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Gross Amount"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Count"] = obj["retCount"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer ID"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Gross Amount"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Count"] = obj["retCount"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer ID"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Gross Amount"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Count"] = obj["retCount"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer ID"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["QTY"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["QTY"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["QTY"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["QTY"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        IMEI: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerId"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["ZD LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerId"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["ZD LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerId"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["ZD LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["RDS Code"] = obj["secPartnerId"] ?? "";
                  obj["RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["ZD LOC"] = obj["loc"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
      return csv;
    },
    ARD: () => {
      ({
        Primary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Tertiary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD ID"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["UAO_URO ID"] = obj["retailer"] ?? "";
                  obj["UAO_URO Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Description"] = obj["brandDescr"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD ID"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["UAO_URO ID"] = obj["retailer"] ?? "";
                  obj["UAO_URO Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Description"] = obj["brandDescr"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD ID"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["UAO_URO ID"] = obj["retailer"] ?? "";
                  obj["UAO_URO Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Description"] = obj["brandDescr"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD ID"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["UAO_URO ID"] = obj["retailer"] ?? "";
                  obj["UAO_URO Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Activation: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ARD"] = obj["primPartnerId"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ARD"] = obj["primPartnerId"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ARD"] = obj["primPartnerId"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ARD"] = obj["primPartnerId"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
      return csv;
    },
    MARD: () => {
      ({
        Primary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["MARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["MARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["MARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
        },
        Tertiary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["MARD ID"] = obj["primPartnerRole"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["UAO_URO ID"] = obj["retailer"] ?? "";
                  obj["UAO_URO Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Description"] = obj["brandDescr"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["MARD ID"] = obj["primPartnerRole"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["UAO_URO ID"] = obj["retailer"] ?? "";
                  obj["UAO_URO Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Description"] = obj["brandDescr"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["MARD ID"] = obj["primPartnerRole"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["UAO_URO ID"] = obj["retailer"] ?? "";
                  obj["UAO_URO Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Description"] = obj["brandDescr"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD ID"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["UAO_URO ID"] = obj["retailer"] ?? "";
                  obj["UAO_URO Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["MARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["MARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["MARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual"] = obj["mtdQty"] ?? "";
                  obj["VAL"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ARD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR Type"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Activation: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["MARD"] = obj["primPartnerId"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["MARD"] = obj["primPartnerId"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["MARD"] = obj["primPartnerId"] ?? "";
                  obj["MARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ARD"] = obj["primPartnerId"] ?? "";
                  obj["ARD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR_Type"] = obj["jprTypeName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
      return csv;
    },
    ITZ: () => {
      ({
        Primary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
        },
        Secondary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["IT RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["IT RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Tertiary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["IT RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["IT RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["IT RDS Code"] = obj["secPartnerRole"] ?? "";
                  obj["IT RDS Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        IMEI: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerId"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["ITZ LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerId"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["ITZ LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerId"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["ITZ LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerId"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["ITZ LOC"] = obj["loc"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
      return csv;
    },
    ITD: () => {
      ({
        Purchase: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
        },
        Tertiary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        IMEI: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerId"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["ITD LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerId"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["ITD LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerId"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["ITD LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerId"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerId"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["IT ZD LOC"] = obj["loc"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
    },
    RZD: () => {
      ({
        Primary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["Brand Description"] = obj["brandDescr"] ?? "";
                  obj["Spart"] = obj["spart"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["Brand Description"] = obj["brandDescr"] ?? "";
                  obj["Spart"] = obj["spart"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["Brand Description"] = obj["brandDescr"] ?? "";
                  obj["Spart"] = obj["spart"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["Brand Description"] = obj["brandDescr"] ?? "";
                  obj["Spart"] = obj["spart"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE VOUCHER": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Agent Id"] = obj["agentId"] ?? "";
                  obj["Booking Pin code"] = obj["bookingPincode"] ?? "";
                  obj["Delivery Status"] = obj["deliveryStatus"] ?? "";
                  obj["Mobile No"] = obj["mobileNo"] ?? "";
                  obj["Create Date"] = obj["voucherCreateDate"] ?? "";
                  obj["Quantity"] = obj["voucherQty"] ?? "";
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Tertiary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["JPR Type Name"] = obj["jprType"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Partner Role Name"] = obj["partnerRoleName"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["RZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        IMEI: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["RZD Code"] = obj["primPartnerId"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["RZD LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["RZD Code"] = obj["primPartnerId"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["RZD LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["RZD Code"] = obj["primPartnerId"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["RZD LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["RZD Code"] = obj["primPartnerId"] ?? "";
                  obj["RZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Retailer Code"] = obj["retailer"] ?? "";
                  obj["Retailer Name"] = obj["retailerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["RZD LOC"] = obj["loc"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
      return csv;
    },
    END: () => {
      ({
        Primary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ED Code"] = obj["primPartnerRole"] ?? "";
                  obj["ED ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ED Code"] = obj["primPartnerRole"] ?? "";
                  obj["ED ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ED Code"] = obj["primPartnerRole"] ?? "";
                  obj["ED ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ED Code"] = obj["primPartnerRole"] ?? "";
                  obj["ED ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ED Code"] = obj["primPartnerRole"] ?? "";
                  obj["ED ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ED Code"] = obj["primPartnerRole"] ?? "";
                  obj["ED Name"] = obj["primPartnerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ED Code"] = obj["primPartnerRole"] ?? "";
                  obj["ED Name"] = obj["primPartnerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ED Code"] = obj["primPartnerRole"] ?? "";
                  obj["ED Name"] = obj["primPartnerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ED Code"] = obj["primPartnerRole"] ?? "";
                  obj["ED Name"] = obj["primPartnerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ED Code"] = obj["primPartnerRole"] ?? "";
                  obj["ED Name"] = obj["primPartnerName"] ?? "";
                  obj["Partner Role Type"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["JC CODE"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["Retailer Category"] = obj["retCategory"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Activation: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ED Code"] = obj["primPartnerId"] ?? "";
                  obj["ED Name"] = obj["primPartnerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["END LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ED Code"] = obj["primPartnerId"] ?? "";
                  obj["ED Name"] = obj["primPartnerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["END LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ED Code"] = obj["primPartnerId"] ?? "";
                  obj["ED Name"] = obj["primPartnerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["END LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ED Code"] = obj["primPartnerId"] ?? "";
                  obj["ED Name"] = obj["primPartnerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["END LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
    },
    DT: () => {
      ({
        Primary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["DT Code"] = obj["primPartnerRole"] ?? "";
                  obj["DT Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["DT Location Code"] = obj["primLocCode"] ?? "";
                  obj["DT Location Name"] = obj["primLocName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["DT Code"] = obj["primPartnerRole"] ?? "";
                  obj["DT Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["DT Location Code"] = obj["primLocCode"] ?? "";
                  obj["DT Location Name"] = obj["primLocName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["DT Code"] = obj["primPartnerRole"] ?? "";
                  obj["DT Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["DT Location Code"] = obj["primLocCode"] ?? "";
                  obj["DT Location Name"] = obj["primLocName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["DT Code"] = obj["primPartnerRole"] ?? "";
                  obj["DT Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Target Qty"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Qty"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["DT Location Code"] = obj["primLocCode"] ?? "";
                  obj["DT Location Name"] = obj["primLocName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["DT Code"] = obj["primPartnerRole"] ?? "";
                  obj["DT Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["Ship to ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
        },
        Activation: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["DT Code"] = obj["primPartnerId"] ?? "";
                  obj["DT Name"] = obj["primPartnerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["DT LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["DT Code"] = obj["primPartnerId"] ?? "";
                  obj["DT Name"] = obj["primPartnerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["DT LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["DT Code"] = obj["primPartnerId"] ?? "";
                  obj["DT Name"] = obj["primPartnerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["DT LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["DT Code"] = obj["primPartnerId"] ?? "";
                  obj["DT Name"] = obj["primPartnerName"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["DT LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
    },
    ZDMT: () => {
      ({
        Primary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["Ship to ID"] = obj["primLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["Ship to ID"] = obj["primLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["Ship to ID"] = obj["primLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["Ship to ID"] = obj["primLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["Ship to ID"] = obj["primLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
        },
        MT: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["CHAIN Code"] = obj["secPartnerRole"] ?? "";
                  obj["CHAIN Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["ZDMT LOC"] = obj["primLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["ZDMT LOC"] = obj["primLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["ZDMT LOC"] = obj["primLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["IT ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["IT ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["ITD Code"] = obj["secPartnerRole"] ?? "";
                  obj["ITD Name"] = obj["secPartnerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  obj["ZDMT LOC"] = obj["primLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["CHAIN Code"] = obj["secPartnerRole"] ?? "";
                  obj["CHAIN Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["ZDMT CHAIN"] = obj["secPartnerRole"] ?? "";
                  obj["ZDMT Chain Name"] = obj["secPartnerName"] ?? "";
                  obj["Store ID"] = obj["retailer"] ?? "";
                  obj["Store Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["ZDMT CHAIN"] = obj["secPartnerRole"] ?? "";
                  obj["ZDMT Chain Name"] = obj["secPartnerName"] ?? "";
                  obj["Store ID"] = obj["retailer"] ?? "";
                  obj["Store Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["ZDMT CHAIN"] = obj["secPartnerRole"] ?? "";
                  obj["ZDMT Chain Name"] = obj["secPartnerName"] ?? "";
                  obj["Store ID"] = obj["retailer"] ?? "";
                  obj["Store Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["ZDMT CHAIN"] = obj["secPartnerRole"] ?? "";
                  obj["ZDMT Chain Name"] = obj["secPartnerName"] ?? "";
                  obj["Store ID"] = obj["retailer"] ?? "";
                  obj["Store Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["CHAIN CODE"] = obj["secPartnerRole"] ?? "";
                  obj["Chain Name"] = obj["secPartnerName"] ?? "";
                  obj["Store ID"] = obj["retailer"] ?? "";
                  obj["Store Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Activation: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerId"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["ZDMT CHAINCode"] = obj["secPartnerId"] ?? "";
                  obj["ZDMT CHAIN Name"] = obj["secPartnerName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["ZDMT LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerId"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["ZDMT CHAINCode"] = obj["secPartnerId"] ?? "";
                  obj["ZDMT CHAIN Name"] = obj["secPartnerName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["ZDMT LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["r4jstate"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerId"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["ZDMT CHAINCode"] = obj["secPartnerId"] ?? "";
                  obj["ZDMT CHAIN Name"] = obj["secPartnerName"] ?? "";
                  obj["IMEI-1"] = obj["imei_1"] ?? "";
                  obj["IMEI-2"] = obj["imei_2"] ?? "";
                  obj["Brand Type"] = obj["brandType"] ?? "";
                  obj["Brand Name"] = obj["brand"] ?? "";
                  obj["Material"] = obj["material"] ?? "";
                  obj["SKU Id"] = obj["skuId"] ?? "";
                  obj["Activation Date"] = obj["rhDate"] ?? "";
                  obj["ZDMT LOC"] = obj["loc"] ?? "";
                  delete obj["region"];
                  delete obj["r4jstate"];
                  delete obj["primPartnerId"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerId"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jprTypeName"];
                  delete obj["imei_1"];
                  delete obj["imei_2"];
                  delete obj["brandType"];
                  delete obj["brand"];
                  delete obj["material"];
                  delete obj["skuId"];
                  delete obj["rhDate"];
                  delete obj["loc"];
                  delete obj["deviceModel"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["CHAIN CODE"] = obj["secPartnerRole"] ?? "";
                  obj["ZDMT Chain Name"] = obj["secPartnerName"] ?? "";
                  obj["Store ID"] = obj["retailer"] ?? "";
                  obj["Store Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
    },
    CHAIN: () => {
      ({
        MT: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["CHAIN Code"] = obj["secPartnerRole"] ?? "";
                  obj["CHAIN Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["Ship to ID"] = obj["secLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["CHAIN Code"] = obj["secPartnerRole"] ?? "";
                  obj["CHAIN Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["Ship to ID"] = obj["secLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["CHAIN Code"] = obj["secPartnerRole"] ?? "";
                  obj["CHAIN Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["Ship to ID"] = obj["secLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["CHAIN Code"] = obj["secPartnerRole"] ?? "";
                  obj["CHAIN Name"] = obj["secPartnerName"] ?? "";
                  obj["Material"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  obj["Brand Name"] = obj["brandName"] ?? "";
                  obj["Ship to ID"] = obj["secLocCode"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["CHAIN Code"] = obj["secPartnerRole"] ?? "";
                  obj["CHAIN Name"] = obj["secPartnerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["% Ach"] = obj["perAch"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["ZDMT CHAIN"] = obj["secPartnerRole"] ?? "";
                  obj["ZDMT Chain Name"] = obj["secPartnerName"] ?? "";
                  obj["Store ID"] = obj["retailer"] ?? "";
                  obj["Store Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["ZDMT CHAIN"] = obj["secPartnerRole"] ?? "";
                  obj["ZDMT Chain Name"] = obj["secPartnerName"] ?? "";
                  obj["Store ID"] = obj["retailer"] ?? "";
                  obj["Store Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            JIOPHONE: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["ZDMT CHAIN"] = obj["secPartnerRole"] ?? "";
                  obj["ZDMT Chain Name"] = obj["secPartnerName"] ?? "";
                  obj["Store ID"] = obj["retailer"] ?? "";
                  obj["Store Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["ZDMT CHAIN"] = obj["secPartnerRole"] ?? "";
                  obj["ZDMT Chain Name"] = obj["secPartnerName"] ?? "";
                  obj["Store ID"] = obj["retailer"] ?? "";
                  obj["Store Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Qty"] = obj["mtdQty"] ?? "";
                  obj["Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            "PARTNER BRAND": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZDMT Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZDMT Name"] = obj["primPartnerName"] ?? "";
                  obj["CHAIN CODE"] = obj["secPartnerRole"] ?? "";
                  obj["Chain Name"] = obj["secPartnerName"] ?? "";
                  obj["Store ID"] = obj["retailer"] ?? "";
                  obj["Store Name"] = obj["retailerName"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
    },

    JC: () => {
      ({
        Primary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Purchase: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Tertiary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        IMEI: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["BRAND"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["MAKTX"] = obj["maktx"] ?? "";
                  obj["MATNR"] = obj["matnr"] ?? "";
                  obj["RH DATE"] = obj["rhDate"] ?? "";
                  obj["IMEI1"] = obj["imei1"] ?? "";
                  obj["IMEI2"] = obj["imei2"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["imei1"];
                  delete obj["imei2"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["rhDate"];
                  delete obj["state"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["BRAND"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["MAKTX"] = obj["maktx"] ?? "";
                  obj["MATNR"] = obj["matnr"] ?? "";
                  obj["RH DATE"] = obj["rhDate"] ?? "";
                  obj["IMEI1"] = obj["imei1"] ?? "";
                  obj["IMEI2"] = obj["imei2"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["imei1"];
                  delete obj["imei2"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["rhDate"];
                  delete obj["state"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["BRAND"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["MAKTX"] = obj["maktx"] ?? "";
                  obj["MATNR"] = obj["matnr"] ?? "";
                  obj["RH DATE"] = obj["rhDate"] ?? "";
                  obj["IMEI1"] = obj["imei1"] ?? "";
                  obj["IMEI2"] = obj["imei2"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["imei1"];
                  delete obj["imei2"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["rhDate"];
                  delete obj["state"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
      return csv;
    },

    JP: () => {
      ({
        Tertiary: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        Sell: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
            ACCESSORIES: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["PARTNER ROLE NAME"] = obj["partnerRoleName"] ?? "";
                  obj["PARTNER ROLE TYPE"] = obj["partnerRoleType"] ?? "";
                  obj["BRAND DESCR"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["PLAN"] = obj["planQty"] ?? "";
                  obj["QUANTITY"] = obj["qty"] ?? "";
                  obj["LMTD QUANTITY"] = obj["lmtdQty"] ?? "";
                  obj["VAL"] = obj["val"] ?? "";
                  obj["LMTD VAL"] = obj["lmtdVal"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["lmtdQty"];
                  delete obj["lmtdVal"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["parentId"];
                  delete obj["parentName"];
                  delete obj["partnerName"];
                  delete obj["partnerId"];
                  delete obj["partnerRoleName"];
                  delete obj["partnerRoleType"];
                  delete obj["planQty"];
                  delete obj["qty"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["state"];
                  delete obj["val"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
        IMEI: () => {
          ({
            LYF: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["BRAND"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["MAKTX"] = obj["maktx"] ?? "";
                  obj["MATNR"] = obj["matnr"] ?? "";
                  obj["RH DATE"] = obj["rhDate"] ?? "";
                  obj["IMEI1"] = obj["imei1"] ?? "";
                  obj["IMEI2"] = obj["imei2"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["imei1"];
                  delete obj["imei2"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["rhDate"];
                  delete obj["state"];
                  return obj;
                });
              return csv;
            },
            JIOFI: () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["BRAND"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["MAKTX"] = obj["maktx"] ?? "";
                  obj["MATNR"] = obj["matnr"] ?? "";
                  obj["RH DATE"] = obj["rhDate"] ?? "";
                  obj["IMEI1"] = obj["imei1"] ?? "";
                  obj["IMEI2"] = obj["imei2"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["imei1"];
                  delete obj["imei2"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["rhDate"];
                  delete obj["state"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["REGION"] = obj["region"] ?? "";
                  obj["STATE"] = obj["state"] ?? "";
                  obj["JC ID"] = obj["jcCode"] ?? "";
                  obj["JC NAME"] = obj["jcName"] ?? "";
                  obj["JIO POINT ID"] = obj["jioPointId"] ?? "";
                  obj["JIO POINT NAME"] = obj["jioPointName"] ?? "";
                  obj["BRAND"] = obj["brandDescr"] ?? "";
                  obj["MODEL"] = obj["model"] ?? "";
                  obj["JPR TYPE NAME"] = obj["jprTypeName"] ?? "";
                  obj["RETAILER ID"] = obj["retailer"] ?? "";
                  obj["RETAILER NAME"] = obj["retailerName"] ?? "";
                  obj["MAKTX"] = obj["maktx"] ?? "";
                  obj["MATNR"] = obj["matnr"] ?? "";
                  obj["RH DATE"] = obj["rhDate"] ?? "";
                  obj["IMEI1"] = obj["imei1"] ?? "";
                  obj["IMEI2"] = obj["imei2"] ?? "";

                  delete obj["brandDescr"];
                  delete obj["brandType"];
                  delete obj["imei1"];
                  delete obj["imei2"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["jioPointId"];
                  delete obj["jioPointName"];
                  delete obj["jprTypeName"];
                  delete obj["maktx"];
                  delete obj["matnr"];
                  delete obj["model"];
                  delete obj["region"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["rhDate"];
                  delete obj["state"];
                  return obj;
                });
              return csv;
            },
            "JIO PHONE NEXT": () => {
              csv =
                content &&
                content.map((obj) => {
                  obj["Region"] = obj["region"] ?? "";
                  obj["State"] = obj["state"] ?? "";
                  obj["ZD Code"] = obj["primPartnerRole"] ?? "";
                  obj["ZD Name"] = obj["primPartnerName"] ?? "";
                  obj["Ship tp ID"] = obj["shipTo"] ?? "";
                  obj["Ship to Name"] = obj["shipToPartnerName"] ?? "";
                  obj["Ship to Role"] = obj["partnerRoleType"] ?? "";
                  obj["Model"] = obj["deviceModel"] ?? "";
                  obj["Plan"] = obj["planQty"] ?? "";
                  obj["Actual Vol"] = obj["mtdQty"] ?? "";
                  obj["Actual Val"] = obj["mtdVal"] ?? "";
                  obj["LMTD Vol"] = obj["lmtdTarQty"] ?? "";
                  obj["LMTD Val"] = obj["lmtdVal"] ?? "";
                  obj["%Ach"] = obj["perAch"] ?? "";
                  obj["JC Code"] = obj["jcCode"] ?? "";
                  obj["JC Name"] = obj["jcName"] ?? "";
                  delete obj["region"];
                  delete obj["state"];
                  delete obj["primPartnerRole"];
                  delete obj["primPartnerName"];
                  delete obj["secPartnerRole"];
                  delete obj["secPartnerName"];
                  delete obj["retailer"];
                  delete obj["retailerName"];
                  delete obj["shipTo"];
                  delete obj["shipToPartnerName"];
                  delete obj["partnerRoleType"];
                  delete obj["deviceModel"];
                  delete obj["planQty"];
                  delete obj["mtdQty"];
                  delete obj["mtdVal"];
                  delete obj["lmtdTarQty"];
                  delete obj["lmtdVal"];
                  delete obj["perAch"];
                  delete obj["jcCode"];
                  delete obj["jcName"];
                  delete obj["brandName"];
                  delete obj["brandDescr"];
                  delete obj["spart"];
                  delete obj["primLocCode"];
                  delete obj["primLocName"];
                  delete obj["secLocCode"];
                  delete obj["secLocName"];
                  delete obj["retCategory"];
                  delete obj["retCount"];
                  delete obj["jprType"];
                  delete obj["partnerRoleName"];
                  delete obj["material"];
                  return obj;
                });
              return csv;
            },
          })[tile]();
          return csv;
        },
      })[tab]();
      return csv;
    },
  })[role]();
  return csv;
};
